import { render } from "./sentNotification.vue?vue&type=template&id=2be8e43a&scoped=true"
import script from "./sentNotification.vue?vue&type=script&lang=js"
export * from "./sentNotification.vue?vue&type=script&lang=js"

import "./sentNotification.vue?vue&type=style&index=0&id=2be8e43a&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be8e43a"]])

export default __exports__